import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { qualityKeys } from '@/shared/lib/query/queryKeys';

import { type ColumnQualityApiParams, getColumnQualityData } from '@/entities/quality/api/getColumnQualityData';

export const useColumnQualityDataQuery = (params: ColumnQualityApiParams, enabled: boolean) => {
  return useQueryWithBoundary({
    queryKey: qualityKeys.columnQuality(params),
    queryFn: () => getColumnQualityData(params),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
